import React from 'react';
import {
    connect
} from 'react-redux';
import {
    actionCreators
} from 'courseLiveStore';
import history from 'common/history'
import { WhiteSpace } from 'antd-mobile';
import './index.css'
import Header from 'component/mobile_header'
import InfoBottom from './components/infoBottom'
import InfoImg from './components/infoImg'
import InfoDes from './components/infoDes'
import InfoTab from './components/infoTab'
import Bottom from './components/topicBottom'
class Courseinfo extends React.Component {
    constructor(props){
      super(props);
      this.state={
          checkBtnMenu: false,
          title:'直播详情'
      }
    }
    componentWillMount() {
        const { getCourseWatched,getCourseInfo, infoList ,user_id,changeCourseInfo,getTopicChatLists,getRecord} = this.props;
         getCourseWatched(this.props.match.params.id)
        getCourseInfo(this.props.match.params.id)
        getTopicChatLists()
         //获取是否收藏
        getRecord(this.props.match.params.id,user_id)
    }
    componentDidMount() {
        document.addEventListener('click', this.hideAllMenu);
    }

    hideAllMenu = () => {
        this.setState({
          checkBtnMenu: false,
        })
    }
    showCheckMenu = (event) => {
      this.stopPropagation(event);
      this.setState({
       checkBtnMenu: !this.state.checkBtnMenu,
      })
    }

    bottomClick(event){
       this.stopPropagation(event);
        this.setState({
         checkBtnMenu:true,
        })
    }
    sendClick(event,value){
      const {addTopicChat,topicId,user_id,user_name} = this.props
      addTopicChat(value,user_id,topicId,user_name)
      this.stopPropagation(event);
          this.setState({
           checkBtnMenu:false,
          })
    }
    //阻止冒泡
    stopPropagation(e) {
       e.nativeEvent.stopImmediatePropagation();
    }
     recordClick(){
      const {addRecord,delRecord,collect,user_id} =this.props
        if(!collect){
          addRecord(this.props.match.params.id,user_id)
        }else{
          delRecord(this.props.match.params.id,user_id)
        }
    }

    render() {
      const {info,subject,collect} =this.props;
        return (
            <div>
              <Header title = {this.state.title}/>
              <div className="container info" >
                <InfoImg thumb={info.get('thumb')}/>
                <InfoDes data={info}/>
                <InfoTab topicClick={(e)=>{this.showCheckMenu(e)}}/>
              </div>
                {
                  this.state.checkBtnMenu?
                   <Bottom
                   bottomClick={(e)=>{this.bottomClick(e)}}
                   sendClick={(e,value)=>{this.sendClick(e,value)}}
                   />:
                   null
                }
              <InfoBottom
                collect={collect}
                recordClick={()=>{this.recordClick()}}
                id={this.props.match.params.id}/>
            </div>

        )
    }
}

const mapState = (state) => ({
    infoList: state.getIn(['courselive', 'infoList']),
    info: state.getIn(['courselive', 'info']),
    subject: state.getIn(['courselive', 'info','subject']),
    topicId: state.getIn(['courselive', 'topicId']),
    user_id: state.getIn(['home','userinfo', 'user_id']),
    user_name: state.getIn(['home','userinfo', 'user_name']),
    collect: state.getIn(['courselive', 'collect']),
})

const mapDispatch = (dispatch) => ({
    getCourseInfo(course_id) {
        dispatch(actionCreators.getCourseInfo(course_id))
    },
    changeCourseInfo(info){
       dispatch(actionCreators.changeCourseInfo(info))
    },
    getTopicChatLists(){
      dispatch(actionCreators.getTopicChatLists())
    },
    addTopicChat(content,user_id,topic_id,user_name){
      dispatch(actionCreators.addTopicChat(content,user_id,topic_id,user_name))
    },
    getRecord(course_id,user_id){
      dispatch(actionCreators.getRecord(course_id,user_id))
    },
    addRecord(course_id,user_id){
      dispatch(actionCreators.addRecord(course_id,user_id))
    },
    delRecord(course_id,user_id){
      dispatch(actionCreators.delRecord(course_id,user_id))
    },
    getCourseWatched(course_id){
        dispatch(actionCreators.getCourseWatched(course_id))
    }
})
export default connect(mapState, mapDispatch)(Courseinfo);
